<template>
    <el-row>
        <el-table :data="currentCraft.size_records"
                  show-summary
                  :summary-method="totalSumMethod">
            <el-table-column width="150" prop="shop_id" label="尺码"/>
            <el-table-column prop="color" label="颜色"/>
            <el-table-column prop="ordered_amount" label="下单数量"/>
            <el-table-column prop="pre_finish_num" label="前一步上报"/>
            <el-table-column align="center" :width="isMdfStatue ? '150' : '80'" prop="num">
                <template slot="header" slot-scope="scope">
                    <span style="margin-right: 4px">通知数量</span>
                    <el-tag size="mini" v-if="planNumChange">**</el-tag>
                </template>

                <template slot-scope="scope">
                    <el-input-number
                            v-if="isMdfStatue"
                            size="mini"
                            :min="0"
                            @change="initChange"
                            v-model="scope.row._num">
                    </el-input-number>

                    <span v-else>{{ scope.row.num }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="has_planed" label="已分配">
                <template slot-scope="scope">
                    <div>
                        <span>{{ scope.row.has_planed }} </span>
                        <el-tooltip v-if="scope.row.num!==scope.row.has_planed" content="已分配数量与下单数量不符"
                                    placement="top">
                            <i class="el-icon-question text-danger"></i>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="80" prop="finish_num" label="上报数量"/>
            <el-table-column width="80" prop="scrap_num" label="报次数量"/>
            <el-table-column width="150" align="center">
                <template slot="header" slot-scope="scope">
                    <span style="margin-right: 4px">标准工价</span>
                    <el-tag size="mini" v-if="priceChange">**</el-tag>
                    <el-input-number
                            v-if="isMdfStatue"
                            controls-position="right"
                            size="mini"
                            :min="0"
                            :step="0.01"
                            @change="syncPrice"
                            v-model="defaultPrice">
                    </el-input-number>
                </template>

                <template slot-scope="scope">
                    <el-input-number
                            v-if="isMdfStatue"
                            size="mini"
                            :step="0.01"
                            :min="0"
                            @change="initChange"
                            v-model="scope.row._price">
                    </el-input-number>
                    <span v-else>{{ scope.row.price }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-row style="margin-top: 8px">
            <el-button
                    style="float: left"
                    :disabled="!isMdfStatue"
                    :loading="updateCraftPlanLoading"
                    @click="updateCurrentCraftRecord"
                    type="primary"
                    icon="el-icon-refresh-right"
                    size="mini">更新
            </el-button>
        </el-row>
    </el-row>

</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "CurrentCraftRecordDetail",
        props: {
            isMdfStatue: {type: Boolean},
            defaultPrice: {type: Number, default: 0},
        },
        data() {
            return {
                updateCraftPlanLoading: false,
                planNumChange: false,
                priceChange: false,
            }
        },
        computed: {
            ...mapState(['currentCraft',])
        },
        methods: {
            /**
             * 对所有的 changed 属性进行检查，并矫正
             */
            initChange() {
                // fieldName:changeValueName
                const fieldChangeMap = new Map([
                    ['num', 'planNumChange'],
                    ['price', 'priceChange'],
                ])

                fieldChangeMap.forEach((changeValueName, fieldName) => {
                    this[changeValueName] = this.checkFieldChange(fieldName)
                })

            },

            /**
             * 检查指定字段与该字段的临时字段是否一致
             *
             * 如果有变动(不一致)返回 true，否则返回 false
             *
             * @fieldName {String} 字段名称
             * @return {Boolean}
             */
            checkFieldChange(fieldName) {
                for (let i = 0; i < this.currentCraft.size_records.length; i++) {
                    const sizeRecord = this.currentCraft.size_records[i]
                    const tempField = '_' + fieldName
                    if (sizeRecord[fieldName] !== sizeRecord[tempField]) {
                        return true
                    }
                }
                return false
            },

            totalSumMethod({columns, data}) {
                const sum = this.$defaultTableSummary({columns, data})
                sum[columns.length - 1] = '/'
                return sum
            },

            syncPrice(currentValue, oldValue) {
                this.initChange()
                this.setPlanNumHasChange(true)
                if (!isNaN(currentValue)) {
                    this.currentCraft.size_records.forEach(sizeRecord => {
                        sizeRecord._price = currentValue
                    })
                }
            },

            /**
             * 在更新操作前，对 数据的处理工作
             */
            beforeUpdate() {
                // 对 tempFields 中的字段，用户的更改保存在 _field 字段中
                // 更新时，需要将将在更改刷新到真正的字段中
                const tempFields = ['num', 'price']
                this.currentCraft.size_records.forEach((sizeRecord) => {
                    tempFields.forEach(field => {
                        const tempField = '_' + field
                        sizeRecord[field] = sizeRecord[tempField]
                    })

                })
            },

            updateCurrentCraftRecord() {
                this.updateCraftPlanLoading = true     // 开始提示加载中
                this.beforeUpdate()

                // 构造 ajax 数据
                const updateUrl = `/order_platform/api/craft_records/${this.currentCraft.id}/`
                const size_records = []
                this.currentCraft.size_records.forEach((sizeRecord) => {
                    size_records.push({
                        id: sizeRecord.id,
                        num: sizeRecord.num,
                        price: sizeRecord.price
                    })
                })
                const data = {
                    size_records
                }
                this.$patchRequest(updateUrl, data).then((response) => {
                    this.updateCurrentCraft(response.data)
                    this.updateCraftPlanLoading = false     // 关闭加载提示
                    this.$message.success('完成通知单的更新')
                    this.initChange()
                }).catch((error) => {
                    this.updateCraftPlanLoading = false
                })

            },
            ...mapMutations([
                'setPlanNumHasChange','updateCurrentCraft',
            ])
        }
    }
</script>

<style scoped>

</style>